import React, { type FC } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { CreateNewNoticeAction, ToggleCreateNoticeModalAction } from '../../../redux/notices/notices-actions'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

export const CreateNoticeDialog: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const createNoticeModalOpen = useAppSelector((state: RootState) => state.notices.createNoticeModalOpen)

  const [newNoticeContents, setNewNoticeContents] = React.useState<string>('')

  const closeModal = (): void => {
    dispatch(ToggleCreateNoticeModalAction())
    setNewNoticeContents('')
  }

  const saveNotice = (): void => {
    dispatch(CreateNewNoticeAction(newNoticeContents))
    closeModal()
  }

  const onClose = (_: React.SyntheticEvent, reason: string): void => {
    // Called when the user clicks outside of modal
    if (reason === 'backdropClick') {
      closeModal()
    }
  }

  return <Dialog
        fullWidth
        maxWidth="md"
        open={createNoticeModalOpen}
        onClose={onClose}
    >
        <DialogTitle style={{ paddingRight: '12px' }}>
            <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
            >
                <b>{t('notices.createNew')}</b>
                <div style={{ cursor: 'pointer' }}>
                    <CloseIcon onClick={closeModal}/>
                </div>
            </div>
        </DialogTitle>

        <DialogContent>
            <TextField
                multiline
                fullWidth
                value={newNoticeContents}
                minRows={3}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setNewNoticeContents(e.currentTarget.value)
                }}
            />
        </DialogContent>

        <DialogActions>
            <Button
                variant='contained'
                onClick={saveNotice}
            >
                {t('common.actions.save')}
            </Button>
        </DialogActions>

    </Dialog>
}
